import { Transaction } from "@crypto-payment-gateway/models"
import { TableMovement } from "../types"
import { TableMovementType } from "../types"

export function convertToInboundOrOutboundStatus(
	status: string,
	type: TableMovementType
): TableMovement["status"] {
	if (type === "INBOUND") {
		return status.toUpperCase()
	} else {
		return status.toLowerCase()
	}
}

// First, extend the Transaction type to include the legacy property names
type TransactionWithLegacyNames = Transaction & {
	transaction_type?: TableMovementType
	transactionType?: TableMovementType
}

export function getTransactionType(
	transaction: any
): TableMovementType | undefined {
	// Cast the transaction to include the legacy property names
	const transactionWithLegacyNames = transaction as TransactionWithLegacyNames
	if (transactionWithLegacyNames.transactionType) {
		return transactionWithLegacyNames.transactionType
	} else if (transactionWithLegacyNames.transaction_type) {
		return transactionWithLegacyNames.transaction_type
	} else if (transactionWithLegacyNames.type) {
		return transactionWithLegacyNames.type as TableMovementType
	} else {
		return undefined
	}
}

